import React from 'react';
import { observer } from 'mobx-react';
import { Card, Icon, Text, Button, Stack } from '@servicetitan/design-system';
import classNames from 'classnames';
import styles from './document-details.less';
import { SignModalStore } from 'src/signature/stores/sign-modal.store';
import { signatureContainer } from 'src/signature/ioc';
import { DocumentPdfViewer } from '../document-pdf-viewer/document-pdf-viewer';

interface DocumentDetailsCardProps {
    header?: string;
    content?: string;
    documentPdfUrl?: string;
    isDocumentSigned?: boolean;
    termsFileName?: string;
    onClickSign: () => void;
    isDisclaimer?: boolean;
}

export const DocumentDetailsCard: React.FC<DocumentDetailsCardProps> = observer(
    ({
        header,
        content,
        documentPdfUrl,
        isDocumentSigned,
        termsFileName,
        onClickSign,
        isDisclaimer,
    }) => {
        const { isPdfLoading, hidePdfLoader } = signatureContainer.get(SignModalStore)!;

        const createMarkup = () => {
            let markup = content;
            if (termsFileName && markup) {
                markup = markup.replace(
                    '{Terms}',
                    `<a href="/api/invoices/agreement?fileName=${termsFileName}" target="_blank">Terms and Conditions</a>` // tslint:disable ter-max-len
                );
            }
            return { __html: markup };
        };

        const handleClickSign = () => {
            !isDocumentSigned && onClickSign();
        };

        return (
            <Card className={classNames(styles.card, { [styles.pdfCard]: !!documentPdfUrl })}>
                <Card.Section className="fw-bold">{header}</Card.Section>
                {documentPdfUrl ? (
                    <Card.Section className={styles.pdfSection}>
                        <DocumentPdfViewer
                            src={documentPdfUrl}
                            onPdfLoad={hidePdfLoader}
                            isLoading={isPdfLoading}
                        />
                    </Card.Section>
                ) : (
                    <Card.Section
                        className={styles.contentSection}
                        dangerouslySetInnerHTML={createMarkup()}
                    />
                )}
                {isDisclaimer ? (
                    <Card.Section sharp="true">
                        <Stack justifyContent="flex-end">
                            <Button primary onClick={handleClickSign}>
                                Continue to Sign
                            </Button>
                        </Stack>
                    </Card.Section>
                ) : (
                    <Card.Section
                        sharp="true"
                        blue={!isDocumentSigned}
                        className={classNames(styles.bottomSection, {
                            'bg-green-500': isDocumentSigned,
                            'cursor-pointer': !isDocumentSigned,
                        })}
                        onClick={handleClickSign}
                    >
                        {isDocumentSigned && (
                            <Icon name="check_circle" className="c-white m-r-1" size={20} />
                        )}
                        <Text className="c-white">
                            {isDocumentSigned ? 'Document Signed' : 'Sign Document'}
                        </Text>
                    </Card.Section>
                )}
            </Card>
        );
    }
);
